export const SET_USER = "USER/SET_USER";
export const SET_USER_SUCCESS = "USER/SET_USER_SUCESSS";
export const SET_USER_FAILURE = "USER/SET_USER_FAILURE";

export const SET_USER_TOKEN_SUCCESS = "USER/SET_USER_TOKEN_SUCCESS";

export const LOG_OUT_USER = "USER/LOG_OUT_USER";
export const LOG_OUT_USER_SUCCESS = "USER/LOG_OUT_USER_SUCCESS";
export const LOG_OUT_USER_FAILURE = "USER/LOG_OUT_USER_FAILURE";

export const CLEAR_ERRORS = "USER/CLEAR_ERRORS";
